import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ThreadLocalRef, 'ThreadLocalRef', ThreadLocalRef);
//endregion
function set_value(_this__u8e3s4, value) {
  _this__u8e3s4.m18(value);
}
function ThreadLocalRef() {
  this.l18_1 = null;
}
protoOf(ThreadLocalRef).c4 = function () {
  set_value(this, null);
};
protoOf(ThreadLocalRef).n18 = function () {
  return this.l18_1;
};
protoOf(ThreadLocalRef).m18 = function (value) {
  this.l18_1 = value;
};
//region block: exports
export {
  ThreadLocalRef as ThreadLocalRef2gwn4e0n07y5w,
};
//endregion

